import React, { FC, useEffect } from 'react'
import { trackGAEvent } from '@moonpig/web-core-analytics'
import { HeroWithPlacard } from './components/WithPlacard'
import { createPromotionImpressionGAEvent } from '../../analytics/createPromotionImpressionGAEvent'
import { FormattedCTAs, useCtaActions } from '../CtaAction/useCtaActions'
import { TextAndImageContainedHero } from './components/WithTextAndImageContained'
import { ModuleHeroFragment } from './__generated__/fragment'
import { ModuleSection } from '../../components/ModuleContainer'
import { Module } from '../types'
import { ContainedFullWidthHero } from './components/ContainedFullWidthHero'

const getHeroForLayout = ({
  layout,
  module,
  formattedCtas,
  onCtaSelect,
}: {
  layout?: string
  module: ModuleHeroFragment
  formattedCtas: FormattedCTAs
  onCtaSelect?: () => void
}) => {
  if (layout === 'home') {
    return (
      <TextAndImageContainedHero
        {...module}
        ctas={formattedCtas}
        onCtaSelect={onCtaSelect}
      />
    )
  }

  if (layout === 'blog' && module.heroVariant === 'FullWidth') {
    return <ContainedFullWidthHero {...module} />
  }

  return (
    <HeroWithPlacard
      {...module}
      ctas={formattedCtas}
      onCtaSelect={onCtaSelect}
    />
  )
}

type HeroModuleProps = Module<ModuleHeroFragment> & {
  onCtaSelect?: () => void
}

export const HeroModule: FC<HeroModuleProps> = ({
  module,
  context: { index, layout },
  onCtaSelect,
}) => {
  const { mapActions } = useCtaActions()
  const { __typename, title, ctas, promotionId } = module
  const formattedCtas = mapActions({
    ctas,
    trackingData: { moduleIndex: index, moduleType: __typename },
    title,
    experiment: promotionId || 'Not bucketed',
  })

  useEffect(() => {
    trackGAEvent(
      createPromotionImpressionGAEvent(
        __typename,
        title,
        promotionId || 'Not bucketed',
      ),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module])

  return (
    <ModuleSection data-testid="module-hero">
      {getHeroForLayout({
        layout,
        module,
        formattedCtas,
        onCtaSelect,
      })}
    </ModuleSection>
  )
}
